import moment from 'moment';
import store from '@/store';

const tokenUtils = {
    tokenTypes: [
        'authorization',
        'refresh'
    ],

    tokenTypeExpirations: {
        authorization: 2, // hours
        refresh: 4, // hours
    },

    prepareToken: (tokenObject) => {
        let expiration = tokenObject.hasOwnProperty('expiredAt') ? moment.utc(tokenObject.expiredAt).local() : moment().add(tokenUtils.tokenTypeExpirations[tokenObject.type], 'hours');

        return {
            type: tokenObject.type,
            value: tokenObject.token,
            expiration: expiration.unix(),
        };
    },

    getToken: (tokenKey) => {
        tokenKey = tokenKey + '_token';

        const stringToken = localStorage.getItem(tokenKey);

        if (!stringToken) {
            return '';
        }

        try {
            const token = JSON.parse(stringToken);

            if (moment().unix() > token.expiration) {
                localStorage.removeItem(tokenKey);

                return '';
            }

            return token.value;
        } catch (e) {
            console.log(e);

            localStorage.removeItem(tokenKey);

            return '';
        }
    },

    hasActualToken: () => {
        for (let i in tokenUtils.tokenTypes) {
            let token = tokenUtils.getToken(tokenUtils.tokenTypes[i]);

            if (token) {
                return true;
            }
        }

        store.state.auth.isAuthenticated = false;

        return false;
    },

    getActualToken: () => {
        for (let i in tokenUtils.tokenTypes) {
            let token = tokenUtils.getToken(tokenUtils.tokenTypes[i]);

            if (token) {
                return token;
            }
        }

        store.state.auth.isAuthenticated = false;

        return '';
    }
};

export default tokenUtils;